import * as React from "react";
import type { SVGProps } from "react";
const SvgMapPinWithInformation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10 15h4a1 1 0 0 0 0-2h-1V9a1 1 0 0 0-1-1h-2a1 1 0 0 0 0 2h1v3h-1a1 1 0 0 0 0 2ZM11.8 7h.2l.2-.02a.64.64 0 0 0 .18-.06.76.76 0 0 0 .18-.09c.052-.037.102-.077.15-.12a1 1 0 0 0 .21-.33 1.001 1.001 0 0 0 0-.78 1 1 0 0 0-.21-.33l-.15-.12a.76.76 0 0 0-.18-.09.64.64 0 0 0-.18-.06.9.9 0 0 0-.4 0 .64.64 0 0 0-.18.08.76.76 0 0 0-.18.09l-.15.12A1.05 1.05 0 0 0 11 6a1 1 0 0 0 .08.4c.05.121.122.233.21.33.048.043.098.083.15.12a.76.76 0 0 0 .18.09.64.64 0 0 0 .18.06Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22a1 1 0 0 1-.72-.3C10.54 20.93 4 14.07 4 10a8 8 0 0 1 16 0c0 4.12-6.54 11-7.28 11.75A1 1 0 0 1 12 22Zm0-18a6 6 0 0 0-6 6c0 2.5 3.84 7.22 6 9.59 2.16-2.37 6-7.09 6-9.59a6 6 0 0 0-6-6Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMapPinWithInformation;
